import AlarmFill from 'assets/Icons/Alarm/AlarmFill';
import RefreshIcon from 'assets/Icons/Common/RefreshIcon';
import IconInfoFill from 'assets/Icons/Notice/Icon_Info_fill';
import Icon_Noti from 'assets/Icons/Notice/Icon_Noti';
import ToastNotice from 'assets/Icons/Notice/ToastNotice';
import ToastNoticeWave from 'assets/Icons/Notice/ToastNoticeWave';
import { DeviceKeyErrorCode } from 'models/MindUp/MindUpApiTypes';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { BorderColor, IconColor, TextColor } from 'styles/Global/colorSemantic';
import { Body4Regular, Title2SemiBold } from 'styles/Global/typography';

export const LinkErrorPage = () => {
    const { state } = useLocation();
    const errorCode = state?.errorCode ?? DeviceKeyErrorCode.INVALID_KEY;

    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    useEffect(() => {
        if (errorCode === DeviceKeyErrorCode.EXPIRED) {
            setTitle('유효 시간이 만료되었어요!');
            setDescription('계속 하시려면 다시 진행해주세요.');
        } else {
            setTitle('유효하지 않은 접근입니다!');
            setDescription('계속 하시려면 다시 진행해주세요.');
        }
    }, [errorCode]);
    return (
        <Layout>
            <ContentsContainer>
                <ToastNoticeWave />
                <TopTextContainer>
                    <Title2SemiBold>{title}</Title2SemiBold>
                    <Body4Regular $color={TextColor.color_text_weak}>{description}</Body4Regular>
                </TopTextContainer>
            </ContentsContainer>
            <ButtonContainer onClick={() => window.location.reload()}>
                <RefreshIcon color={IconColor.color_icon_light} />
                다시 시도
            </ButtonContainer>
        </Layout>
    );
};

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px 16px 36px;
    min-height: 100vh;
    height: 100%;
    gap: 36px;
`;

const ContentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;
`;

const ButtonContainer = styled.div`
    display: flex;
    width: 200px;
    height: 52px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${BorderColor.color_border_light};
    border-radius: 8px;
    gap: 4px;
`;

const TopTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
`;
